
import React, { Component, Fragment } from 'react';
import ImageUploading from 'react-images-uploading';
import { Button, Col, Container, Row } from 'reactstrap';
import { ArcaClientImageServer } from '../../../code/ArcaClientImageServer';

export class PhotoUploadPanel extends Component {

    constructor(props) {
        super(props);

        this.state = {
            images: null,
        };
    }

    onChange(imageList, addUpdateIndex) {

        let { folder, name, imageUpdated, uploadStarted } = this.props

        // data for submit
        console.log(imageList, addUpdateIndex);
        this.setState({ imageList });

        uploadStarted()

        ArcaClientImageServer.SavePicture(
            imageList[0].data_url,
            folder,
            name,
            (() => { imageUpdated && imageUpdated(); }),
            ((msg) => alert(msg)));
    };

    render() {
        let { images, maxNumber } = this.state

        return (
            <Fragment>
                <Container>
                    <Row>
                        <Col>
                            <ImageUploading
                                multiple
                                value={images}
                                onChange={this.onChange.bind(this)}
                                maxNumber={maxNumber}
                                dataURLKey="data_url">
                                {({
                                    onImageUpload,
                                }) => (

                                    <Button
                                        className={'primaryButton'}
                                        onClick={onImageUpload}>
                                        Select image
                                    </Button>
                                )}
                            </ImageUploading>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        );
    }
}